import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS, type Lang } from '@/data/categories';

export function usePageLanguage(lang: string) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const validLang: Lang = SUPPORTED_LANGS.includes(lang as Lang) ? (lang as Lang) : 'en';
    document.documentElement.lang = validLang;
    if (i18n.language !== validLang) {
      i18n.changeLanguage(validLang);
    }
  }, [lang, i18n]);
}